import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-work-order-status-text',
    templateUrl: './work.order.status.text.component.html'
})

export class WorkOrderStatusTextComponent implements OnInit {
    @Input() workOrderStatus: any;

    status: number;

    ngOnInit() {

        if (typeof(this.workOrderStatus) === 'number') {
            this.status = this.workOrderStatus;
            return;
        }

        switch (this.workOrderStatus) {
            case 'NotStarted':
                this.status = 1;
                break;
            case 'InProgress':
                this.status = 2;
                break;
            case 'OnHold':
                this.status = 3;
                break;
            case 'Completed':
                this.status = 4;
                break;
        }
    }
}

